// extracted by mini-css-extract-plugin
export default {"Box":"absolutelyPositionedBox_Box__RrOVv"};